module.exports = __webpack_public_path__ + "static/transposh1-36ccc23e7a096e5d7caa139a7da5e148.jpg";